import React from "react";
import { useForceSaveOnUnmount } from "../hooks/useAutoSave";

interface AddLocationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onStartExploration: () => void;
}

export const AddLocationModal: React.FC<AddLocationModalProps> = ({ isOpen, onClose, onStartExploration }) => {
  // Force save when modal closes
  useForceSaveOnUnmount();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3">
      <div className="ledger-shell max-w-md w-full text-sm">
        <div className="p-4">
          <h2 className="text-base font-semibold uppercase tracking-wider mb-3">Add Location</h2>
          <p className="text-[#E6E5D3] opacity-90 mb-4 text-xs">
            This will start the exploration process, allowing you to discover and explore locations using the standard exploration mechanics.
          </p>
          <div className="flex gap-3">
            <button
              className="flex-1 ledger-btn px-3 py-2 text-xs font-semibold uppercase tracking-wider"
              onClick={() => {
                onStartExploration();
                onClose();
              }}
            >
              Start Exploration
            </button>
            <button
              className="flex-1 ledger-btn px-3 py-2 text-xs font-semibold uppercase tracking-wider"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

